import styled, { css } from 'styled-components';

import { weights } from '@utils/fonts';
import colors from '@utils/colors';
import { mq } from '@utils/responsive';
import { fontStyles, Heading } from '@components/type';
import { textBoxHeadings } from '../Text/styles';

export const Wrapper = styled.div`
  margin-bottom: 24px;
  position: relative;

  ${mq.gtms`
    margin-bottom: 40px;
  `}
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  gap: 24px;

  ${mq.gtms`
    gap: 60px;
    max-width: 1280px;
    margin: 0 auto;

    ${(props) =>
  props.align === 'left'
    ? css`
      flex-direction: row;
    `
    : css`
      flex-direction: row-reverse;
    `}
  `}
`;

export const StaggeredInner = styled.div`
  position: absolute;
  bottom: 0;
  top: 100px;
  left: 0;
  right: 0;
  z-index: -1;

  background-color: ${(props) =>
    props.type === 'staggered'
      ? getThemeStyles(props.colorTheme).background
      : 'transparent'};


  & > svg:first-of-type {
    display: ${(props) => (props.type === 'staggered' ? 'block' : 'none')};
    fill: ${(props) => getThemeStyles(props.colorTheme).background};
    vertical-align: bottom;
    position: absolute;
    top: -40px;
    height: 40px;
    width: 100%;
  }

  & > svg:last-of-type {
    display: ${(props) => (props.type === 'staggered' ? 'block' : 'none')};
    fill: ${(props) => getThemeStyles(props.colorTheme).background};
    transform: scale(1, -1) translateY(1px);
    vertical-align: top;
    position: absolute;
    height: 45px;
    width: 100%;
    bottom: -45px;
  }
`

export const Content = styled.div`
  ${mq.gtms`
    flex: 1 1;
  `};

  & > svg:first-of-type {
    fill: ${(props) => getThemeStyles(props.colorTheme).swirl};
    stroke: ${(props) => getThemeStyles(props.colorTheme).swirl};
  }
`;

export const Title = styled(Heading)`
  margin-top: 24px;
  margin-bottom: 36px;
  text-transform: uppercase;
  color: ${(props) => getThemeStyles(props.colorTheme).text};

  ${mq.gtms`
    max-width: 70%;
    margin-top: 0;
  `}
`;

export const TextWrapper = styled.div`
  margin-bottom: 24px;

  &:has(ul), &:has(ol) {
    margin-bottom: 0;
  }

  & p {
    ${fontStyles.normal};
  }

  ${textBoxHeadings};

  & blockquote {
    ${fontStyles.blockquote};
  }

  & em {
    ${fontStyles.em};
  }

  & strong {
    ${fontStyles.strong};
  }

  & ul {
    ${fontStyles.normal};
    padding-left: 40px;
    list-style-type: disc;
  }
`;

export const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${mq.gtms`
    flex: 1 1;
    margin-top: 8px;
  `};
`;

export const VideoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Credit = styled.div`
  font-weight: ${weights.BOLD};
  font-family: ${props => props.theme.fonts.SANS};
  font-size: 12px;
`;

function getThemeStyles(theme) {
  switch (theme) {
    case 'blue':
      return {
        background: colors.B100,
        swirl: colors.B200,
        text: colors.B500,
      };
    case 'green':
      return {
        background: colors.G100,
        swirl: colors.G200,
        text: colors.G500,
      };
    case 'orange':
      return {
        background: colors.O100,
        swirl: colors.O200,
        text: colors.O500,
      };
    case 'purple':
      return {
        background: colors.P100,
        swirl: colors.P200,
        text: colors.P500,
      };
    default:
      return {
        background: colors.Y100,
        swirl: colors.Y500,
        text: colors.B500,
      };
  }
}
